<template>
  <v-content>
    <v-container>
      <v-layout>
        <v-flex>
          <div>
            <div id="firebaseui-auth-container" />
            <div id="loader">
              Now Loading...
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import firebase, { ui } from "@/plugins/firebase";
import "firebaseui/dist/firebaseui.css";

export default {
  mounted() {
    console.log(process.env.VUE_APP_SUCCESSURL)
    ui.start("#firebaseui-auth-container", {
      callbacks: {
        uiShown: () => {
          document.getElementById("loader").style.display = "none";
        }
      },
      signInFlow: "popup",
      signInSuccessUrl: process.env.VUE_APP_SUCCESSURL,
      signInOptions: [firebase.auth.TwitterAuthProvider.PROVIDER_ID]
    });
  }
};
</script>

<style>
.firebaseui-idp-twitter, .firebaseui-idp-twitter:hover, .mdl-button.firebaseui-idp-twitter:active, .mdl-button.firebaseui-idp-twitter:focus {
  background-color: #1976D2;
}
</style>
